import Vue from 'vue'
import Notify from './Notify.vue'

let defaultOptions = {
    text: '',
    title: null,
    color: 'info',
    timeout: 4500
}
let cmp = null

function create(options) {
    let component = new Vue(Notify)
    options = { ...defaultOptions, ...options }
    Object.assign(component, options)
    let app = document.getElementsByClassName('v-application--wrap')
    app[0].appendChild(component.$mount().$el)
  
    return component
}

function show(text, options = {}) {
    options.text = text
    if (!options.timeout && options.color == 'error') {
        options.timeout = 0
    }

    let component = document.getElementsByClassName('v-notify')
    if (component.length) {
        component[0].remove()
        if (cmp) {
            cmp.$destroy()
        }
    }

    if (!cmp) {
        create(options)
    }
}

function shorts(options) {
    const colors = ['success', 'info', 'error', 'warning']
    const methods = {}

    colors.forEach(color => {
        methods[color] = (message, options) => show(message, { color, ...options })
    })

    if (options.shorts) {
        for (let key in options.shorts) {
            const localOptions = options.shorts[key]
            methods[key] = (message, options) => show(message, { ...localOptions, ...options })
        }
    }

    return methods
}

let index = Object.assign(show, {
    defaultOptions,
    ...shorts(defaultOptions)
})
window.notify = index

export default index



// WEBPACK FOOTER //
// ./src/components/Notify/index.js